//
//
//
//
//
//
//
export default {
  inject: ["main"]
};